export default "__VITE_ASSET__Pv50EOuO__"